
import { format, parseISO } from 'date-fns'
import minutesToHoursString from '@/helpers/minutesToHoursString'

export default {
  props: {
    leg: {
      type: Object,
      default: null
    },
  },
  computed: {
    parsedDepTime () {
      return parseISO(this.leg.depTime)
    },
    arrivalTimeFormatted () {
      return format(parseISO(this.leg.arrTime), 'p')
    },
    departureTimeFormatted () {
      return format(this.parsedDepTime, 'p')
    },
    departureDateFormatted () {
      return format(this.parsedDepTime, 'yyyy-MM-dd')
    },
    flightTime () {
      return minutesToHoursString(this.leg.duration)
    },
    legTypeLabel () {
      const key = `flights.result.legType.${this.leg.type}`
      return this.leg.type && this.$te(key) ? this.$t(key) : ''
    }
  }
}
